module.exports = __webpack_public_path__ + "img/medical-record.59c0cf91.svg";